/*
 *
 * RefoundUnavailable
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 19-Mar-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  CF_ISP_CONTACTS_NOT_CERTIFIED: {
    title: (
      <PortalMessage
        id='t.app.ttl.refound.unavailable.ips_contacts_not_certified.title'
        defaultMessage='Storno non attivo sui punti vendita Intesa Sanpaolo'
      />
    ),
    description: (
      <PortalMessage
        id='t.app.ttl.refound.unavailable.ips_contacts_not_certified.description'
        defaultMessage='Per poter stornare è necessario essere in possesso del <b>contratto del servizio a distanza Intesa Sanpaolo - My Key</b>. Se ne sei in possesso e hai il <b>numero di telefono certificato ed email validata, inseriscili nel profilo Nexi Business</b>.<br/><br/>In alternativa, <b>contatta la Filiale Digitale di Intesa Sanpaolo</b> al <b>800 303 303</b> dall’Italia (oppure +39 011 8019 200 dall’estero) per verificare la tua posizione.'
      />
    ),
    primaryButtonLabel: (
      <PortalMessage
        id='t.app.okUnderstood'
        defaultMessage='Ok, ho capito'
      />
    )
  },
  CF_NOT_ISP: {
    title: (
      <PortalMessage
        id='t.app.ttl.refound.unavailable.cf_not_isp.title'
        defaultMessage='Storno non attivo sui punti vendita Intesa Sanpaolo'
      />
    ),
    description: (
      <PortalMessage
        id='t.app.ttl.refound.unavailable.cf_not_isp.description'
        defaultMessage='<b>Contatta la Filiale Digitale di Intesa Sanpaolo</b> al <b>800 303 303</b> dall’Italia (oppure +39 011 8019 200 dall’estero) per verificare la tua posizione.'
      />
    ),
    primaryButtonLabel: (
      <PortalMessage
        id='t.app.okUnderstood'
        defaultMessage='Ok, ho capito'
      />
    )
  }
}

export default formattedMessage
